import ReactDOM from 'react-dom';
import { delay } from 'bluebird';
import ActivationSteps from './ActivationScreen';
import { attachMessageListener, getDeviceInfo, setToken, checkExtension } from './Upshow.js';
import { autoActivateWebview, getWebviewName, getAccessToken, createActivationScreenContainer, removeActivationScreenContainer, storeAccessToken } from './utils/activation';
import { notifyAndroidAppStarted, setupAndroidSkykitChecks } from './utils/android.js';


class Activation {
    webviewName = null;
    accessToken = null;
    activationCode = null;

    constructor () {
        this.start = this.start.bind(this);
        this.askForActivation = this.askForActivation.bind(this);
        this.autoActivate = this.autoActivate.bind(this);
    }

    async waitForChromeOSExtension (DeviceUptime) {
        let first = 'Device is initializing... please standby.';
        let second = '';

        if (DeviceUptime > 10000) {
            first = 'Device encountered an issue during initialization. Please restart.';
            second = 'If issues persist, check for pending updates or contact support.';
        }

        let div = document.createElement('div');
        div.innerHTML = `<div class="logo">
                    <img alt="logo" src='https://cdn.upshow.tv/ui-assets/EP_PBU_Logo.png'/>
                </div>
                <div class="first">${first}</div>
                <div class="second">${second}</div>`;
        div.id = 'waiting';
        document.body.insertBefore(div, document.getElementById('root'));
        await delay(3000);
        checkExtension();
        return this.start();
    }

    start () {
        document.getElementById('waiting')?.remove();

        // Do I have a webviewname on the url?
        this.webviewName = getWebviewName();
        if (this.webviewName) {
            return this.autoActivate();
        }

        // Maybe I'm already activated
        this.accessToken = getAccessToken();
        if (this.accessToken) {
            setToken(this.accessToken);

            return this.accessToken;
        }

        // If we are in a PWA and the extension is not loaded yet, we wait for it
        const { extensionAvailable, model, DeviceUptime, deviceId } = getDeviceInfo();
        if (model === 'ChromeOS PWA' && !deviceId) {
            if (!extensionAvailable) {
                return this.waitForChromeOSExtension(DeviceUptime);
            }
        }
        // I'm secondary output & primary enrolled IMPELEMNT HERE

        return this.askForActivation();
    }

    askForActivation() {
        const model = getDeviceInfo().model;

        return new Promise((resolve) => {
            // Create activation screen div
            createActivationScreenContainer();

            const handleActivationComplete = (token) => {
                // Clean activation screens and resolve
                removeActivationScreenContainer();
                resolve(token);
            };

            // Render activation screen with completion callback
            ReactDOM.render(
                <ActivationSteps onActivationComplete={handleActivationComplete} />,
                document.getElementById('activation-screen')
            );

            // Setup Android Skykit checks button and notify the app started
            setupAndroidSkykitChecks(model);
            notifyAndroidAppStarted();

            attachMessageListener();
        });
    }


    async autoActivate() {
        const activationResult = await autoActivateWebview(this.webviewName);

        if (activationResult.inactive) {
            return;
        } else if (activationResult.active) {
            this.accessToken = activationResult.token;
            storeAccessToken(this.accessToken);
            return this.accessToken;
        } else {
            await delay(1000);
            return this.start();
        }
    }
}

export default Activation;
